module.exports = "/_next/static/images/architectureEngineeringServices-2e5e9848a057a21f05d852317bcb47df.webp";